import { Helmet } from "react-helmet"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion"
import "react-accessible-accordion/dist/fancy-example.css"

export const currentPath = window.location.pathname
export const currentDomain = window.location.origin

export default function ResponsibleGaming() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Responsible Gaming - FGH - Your One-Stop Gaming Site</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="Learn about responsible gaming practices and how to play safely." />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>

      <div className="main-body-content main-container-global-adjusted-padding tnc-page">
        <h1 className="fgh-h1-style">Responsible Gaming</h1>
        <p>
          At FGH, we are committed to creating unforgettable experiences every
          day. That commitment extends to every facet of our website. However,
          some may develop a gambling addiction due to a misportrayal of gaming.
          FGH takes this matter very seriously, and we are wholeheartedly
          committed to spreading awareness about gambling addiction. We urge all
          players to be responsible in their gaming, and to enjoy our games in
          moderation.
        </p>
        <Accordion preExpanded={["a"]}>
          {" "}
          <AccordionItem uuid="a">
            <AccordionItemHeading>
              <AccordionItemButton>Responsibility</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p>
                Gambling should be seen as a fun and exciting way to spend time,
                and not as an income. It is difficult for some players to
                perceive gambling only as a means of relaxation and risking only
                what they can afford, as most players do. If you are worried
                that gambling has a negative impact on your life or lives of
                your close ones, the following questions can help you figure it
                out.
              </p>
              <ol className="responsible-gaming-ol">
                <li>
                  Does gambling distract you from going to work or school?
                </li>
                <li>Do you take gambling as a way to get income?</li>
                <li>
                  Is gambling to you simply a way to spend some time or avoid
                  boredom?
                </li>
                <li>
                  Have you lost interest in family, friends and hobbies because
                  of gambling?
                </li>
                <li>
                  Have you ever lied, stole or borrowed money for the purpose of
                  gambling or to pay gambling debts?
                </li>
                <li>
                  Do you feel depressed or even suicidal because of gambling?
                </li>
                <li>
                  Do you feel lost and desperate when you run out of money while
                  gambling?
                </li>
              </ol>
              <p>
                If your answer to most of the questions is yes, there is a
                possibility that you have a gambling addiction.
              </p>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>How Can We Help?</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p>
                If you suspect that you may be developing a gambling addiction,
                you can always seek help through our round-the-clock customer
                service team. Our team will assist you with your problems to the
                best of our ability, no matter how big or small the issue may
                be. Prevention is always better than cure.
              </p>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>
    </>
  )
}
